export default "__VITE_ASSET__Do1oxSeG__"